import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeInfoComponent } from './badge-info.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    BadgeInfoComponent
  ],
  imports: [
    CommonModule,
    NgbModule
  ],
  exports: [
    BadgeInfoComponent
  ]
})
export class BadgeInfoModule { }
